(() => {
  if (window.luppoStoreReady) return;
  window.luppoStoreReady = true;
  const root = window.Shopify?.routes?.root || '/';
  const filterForm = document.querySelector('[data-lp-filters]');
  if (filterForm) {
    const url = new URL(location.href);
    const hasFilters = [...url.searchParams.keys()].some(key => key.startsWith('filter.'));
    const needsNormalization = hasFilters && url.searchParams.getAll('filter.v.availability').join(',') !== '1';
    if (needsNormalization) {
      url.searchParams.set('filter.v.availability', '1');
      url.searchParams.delete('page');
      location.replace(url.href);
      return;
    }
    filterForm.querySelectorAll('details').forEach(panel => panel.addEventListener('toggle', () => {
      if (panel.open) filterForm.querySelectorAll('details').forEach(other => { if (other !== panel) other.open = false; });
    }));
    const priceFrom = filterForm.querySelector('[name="filter.v.price.gte"]');
    const priceTo = filterForm.querySelector('[name="filter.v.price.lte"]');
    if (priceFrom && priceTo) {
      const updatePriceBounds = () => { priceTo.min = priceFrom.value || '0'; };
      priceFrom.addEventListener('input', updatePriceBounds);
      updatePriceBounds();
    }
    filterForm.addEventListener('submit', event => {
      event.preventDefault();
      const destination = new URL(filterForm.action, location.href);
      const data = new FormData(filterForm);
      for (const key of new Set(data.keys())) {
        const values = data.getAll(key).map(String).filter(value => value !== '');
        values.forEach(value => destination.searchParams.append(key, value));
      }
      destination.searchParams.set('filter.v.availability', '1');
      location.assign(destination.href);
    });
  }
  const quick = document.querySelector('#lp-quick-dialog');
  const bag = document.querySelector('#lp-bag-dialog');
  let returnFocus;
  let complementInstance = 0;
  const complementRequests = new WeakMap();
  async function loadComplements(host, productId, sectionId = 'luppo-complementary') {
    complementRequests.get(host)?.abort();
    const controller = new AbortController();
    complementRequests.set(host, controller);
    host.hidden = true;
    if (!productId) return;
    try {
      const url = new URL(root + 'recommendations/products', document.baseURI);
      url.search = new URLSearchParams({section_id:sectionId,product_id:productId,limit:'3',intent:'complementary'});
      const response = await fetch(url, {signal:controller.signal});
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('[data-complement-content]');
      if (!content?.querySelector('.lp-complement-card') || controller.signal.aborted) return;
      // Section fragments can appear on the page and in the bag simultaneously.
      const suffix = '-look-' + (++complementInstance);
      content.querySelectorAll('[id]').forEach(el => {el.id += suffix;});
      host.replaceChildren(content);
      host.hidden = false;
    } catch (error) { /* Optional suggestions never interrupt purchasing. */ }
  }
  function loadPageComplements(scope = document) {
    scope.querySelectorAll('[data-complementary]').forEach(host => loadComplements(host,host.dataset.productId,host.dataset.sectionId));
  }
  loadPageComplements();
  document.addEventListener('shopify:section:load', e => loadPageComplements(e.target));

  document.addEventListener('click', e => {
    const button = e.target.closest('[data-quick]');
    if (button) {
      const template = document.getElementById(button.dataset.quick);
      if (!template) return;
      returnFocus = button;
      quick.querySelector('[data-quick-content]').replaceChildren(template.content.cloneNode(true));
      if (bag?.open) bag.close();
      quick.showModal();
      quick.scrollTop=0;
    }
    const closeButton = e.target.closest('.lp-dialog [data-close]');
    if (closeButton) closeButton.closest('.lp-dialog')?.close();
    const arrow = e.target.closest('[data-scroll-products]');
    if (arrow) {
      const track = document.querySelector('#' + arrow.dataset.track);
      track.scrollBy({left: Number(arrow.dataset.scrollProducts) * track.clientWidth * .82, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    const filter = e.target.closest('[data-shop-tab]');
    if (filter) {
      const shop=filter.closest('[data-shop-section]') || document;
      shop.querySelectorAll('[data-shop-tab]').forEach(t => t.setAttribute('aria-pressed', String(t === filter)));
      shop.querySelectorAll('[data-shop-panel]').forEach(p => {p.hidden = p.id !== filter.dataset.shopTab;});
    }
    const thumb = e.target.closest('[data-gallery-image]');
    if (thumb) {
      const photo = document.querySelector('[data-main-photo]');
      photo.src = thumb.dataset.galleryImage;
      photo.removeAttribute('srcset');
      photo.alt = thumb.querySelector('img').alt;
      document.querySelectorAll('[data-gallery-image]').forEach(t => t.setAttribute('aria-pressed',String(t === thumb)));
    }
  });
  document.querySelectorAll('.lp-dialog').forEach(d => {
    d.addEventListener('click', e => {if(e.target === d) {const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}});
    d.addEventListener('close', () => returnFocus?.focus());
  });
  document.addEventListener('change', e => {
    if (!e.target.matches('[data-variant-select]')) return;
    const option = e.target.selectedOptions[0], form = e.target.closest('form');
    form.querySelector('[data-variant-price]').textContent = option.dataset.price;
    const photo = form.closest('.lp-complement-card')?.querySelector('.lp-complement-photo img') || form.closest('.lp-quick-layout')?.querySelector('.lp-quick-photo img') || document.querySelector('[data-main-photo]');
    if (photo && option.dataset.image) { photo.src = option.dataset.image; photo.removeAttribute('srcset'); }
    if (!form.closest('dialog') && !form.classList.contains('lp-complement-buy')) { const url = new URL(location.href); url.searchParams.set('variant',option.value); history.replaceState({},'',url); }
  });
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!form.matches('.lp-buy')) return;
    e.preventDefault();
    const submit = form.querySelector('[type="submit"]'), status = form.querySelector('[role="status"]');
    if (submit.disabled) return;
    submit.disabled = true; submit.setAttribute('aria-busy','true'); status.textContent = 'Adding to your bag…';
    try {
      const response = await fetch(root + 'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      const result = await response.json();
      if(!response.ok) throw new Error(result.description || 'This option is no longer available. Please choose another.');
      status.textContent = 'Added to your bag.';
      const cartResponse = await fetch(root + 'cart.js',{headers:{Accept:'application/json'}});
      if (!cartResponse.ok) {location.href=root+'cart';return;}
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=cart.item_count);
      bag.querySelector('[data-bag-summary]').textContent = cart.item_count + (cart.item_count===1?' piece':' pieces') + ' in your bag · ' + new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:cart.currency}).format(cart.total_price/100);
      if(quick.open) quick.close(); else returnFocus=submit;
      const suggestions = bag.querySelector('[data-bag-complements]');
      if (!form.closest('#lp-bag-dialog')) bag.dataset.sourceProduct = String(result.product_id || form.dataset.productId || '');
      if (!bag.open) bag.showModal();
      bag.scrollTop = 0;
      if (suggestions) loadComplements(suggestions,bag.dataset.sourceProduct);
      loadPageComplements();
    } catch(error) { status.textContent = error.message || 'Please try again.'; }
    finally { submit.disabled=false; submit.removeAttribute('aria-busy'); }
  });
})();

